/**
 * Created by Ram on 12/05/2017.
 */

import React, { Component } from "react";
import MapAnalyticsMap from "./MapAnalyticsMap";
import LoadingSpinner from "./components/LoadingSpinner";

class MapAnalytics extends Component {
  render() {
    let allDevices = [];
    let { devices, isLoading } = this.props.loadData;
    let totalTriggersCount = 0;

    if (devices.length) {
      allDevices = devices.map(device => {
        const testInstanceDevice = this.props.loadData.testInstance.devices.find(
          ({ deviceId }) => deviceId === device._id
        );
        let triggersCount = 0;
        if (
          testInstanceDevice &&
          testInstanceDevice.log &&
          testInstanceDevice.log.triggers &&
          testInstanceDevice.log.triggers.length
        ) {
          triggersCount = testInstanceDevice.log.triggers.length;
          totalTriggersCount += triggersCount;
        }
        return (
          <option key={device._id} value={device._id} disabled={!triggersCount}>
            {device.name} ({triggersCount})
          </option>
        );
      });
    }

    const deviceCounts = {
      Android: devices.filter(({ os }) => os === "Android").length,
      iOS: devices.filter(({ os }) => os === "iOS").length
    };

    let mapComponent;
    if (isLoading) {
      mapComponent = (
        <h4>
          <LoadingSpinner />
        </h4>
      );
    } else {
      mapComponent = (
        <div className="analytics-map">
          <MapAnalyticsMap
            checkins={this.props.loadData.allCheckins}
            fences={this.props.loadData.fences}
            showFences={this.props.loadData.showFences}
          />
        </div>
      );
    }

    return (
      <div className="map-analytics-main-div wide-view">
        <h4>Map Analytics</h4>

        <div className="map-analytics-options text-center">
          <div>
            <label>Show Route: </label>
            <input
              type="checkbox"
              name="showRoute"
              onChange={this.props.updateShowRoute}
              checked={this.props.loadData.showRoute}
              disabled={true}
            />
          </div>

          <div>
            <label>Show Fences: </label>
            <input
              type="checkbox"
              name="showFences"
              onChange={this.props.updateRuleDownload}
              checked={this.props.loadData.showFences}
            />
          </div>

          <div>
            <label>By OS:</label>
            <select
              name="osSelected"
              value={this.props.loadData.osSelected}
              onChange={this.props.updateOs}
            >
              <option key="Both" value="Both">
                Both ({deviceCounts["Android"] + deviceCounts["iOS"]} devices)
              </option>
              <option
                key="Android"
                value="Android"
                disabled={!deviceCounts["Android"]}
              >
                Android ({deviceCounts["Android"]})
              </option>
              <option key="iOS" value="iOS" disabled={!deviceCounts["iOS"]}>
                iOS ({deviceCounts["iOS"]})
              </option>
            </select>
          </div>

          <div>
            <label>Device: </label>
            <select
              name="deviceSelected"
              value={this.props.loadData.deviceSelected}
              onChange={this.props.updateDevice}
            >
              <option key="device-all" value="device-all">
                All ({totalTriggersCount} triggers)
              </option>
              {allDevices}
            </select>
          </div>
        </div>

        {mapComponent}
      </div>
    ); //return
  } //render
} //MapAnalytics

export default MapAnalytics;
